module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huanqiu-logRecord-page-out"
  }, [_c('topNav', {
    ref: "topnav",
    attrs: {
      "selfMethod": "1",
      "title": "日志查看"
    },
    on: {
      "leftClick": _vm.goBack
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "房态更新日志",
      "to": "/opera/logRecordRoom",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "楼栋绑定日志",
      "to": "/opera/logRecordBindBuild",
      "is-link": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-01b61780","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/huanQiuPage/logRecordHuanQiu.vue
// module id = 1721
// module chunks = 107